export const planFeatures = [
  {
    key: '1',
    title: 'Weekly column by our team',
    basic: true,
    standard: true,
    pro: true,
    group: true,
  },
  {
    key: '2',
    title: 'Premium Podcast subscription',
    basic: true,
    standard: true,
    pro: true,
    group: true,
  },
  {
    key: '3',
    title: 'Our flagship: The Daily Briefing',
    basic: false,
    standard: true,
    pro: true,
    group: true,
  },
  {
    key: '4',
    title: 'Key takeaways in bullet form',
    basic: false,
    standard: true,
    pro: true,
    group: true,
  },
  // {
  //   key: '5',
  //   title: 'Quarterly zoom conference',
  //   basic: false,
  //   standard: false,
  //   pro: true,
  //   group: true,
  // },
  {
    key: '6',
    title: 'Podcast transcripts',
    basic: false,
    standard: false,
    pro: true,
    group: true,
  },
  {
    key: '7',
    title: 'Q&A with analysts',
    basic: false,
    standard: false,
    pro: true,
    group: true,
  },
  {
    key: '8',
    title: 'One-to-one discussions',
    basic: false,
    standard: false,
    pro: false,
    group: true,
  },
  {
    key: '9',
    title: 'In person meetings',
    basic: false,
    standard: false,
    pro: false,
    group: true,
  },
  {
    key: '10',
    title: 'Personalised contracts',
    basic: false,
    standard: false,
    pro: false,
    group: true,
  },
];

export const COUNTRIES_VAT = [
  { code: "AT", country: "Austria", vat: 20 },
  { code: "BE", country: "Belgium", vat: 21 },
  { code: "BG", country: "Bulgaria", vat: 20 },
  { code: "CY", country: "Cyprus", vat: 19 },
  { code: "CZ", country: "Czech Republic", vat: 21 },
  { code: "DE", country: "Germany", vat: 19 },
  { code: "DK", country: "Denmark", vat: 25 },
  { code: "EE", country: "Estonia", vat: 20 },
  { code: "ES", country: "Spain – Península y Baleares", vat: 21 },
  { code: "FI", country: "Finland", vat: 24 },
  { code: "FR", country: "France", vat: 20 },
  { code: "GR", country: "Greece", vat: 24 },
  { code: "HR", country: "Croatia", vat: 25 },
  { code: "HU", country: "Hungary", vat: 27 },
  { code: "IE", country: "Ireland", vat: 23 },
  { code: "IT", country: "Italy", vat: 22 },
  { code: "LT", country: "Lithuania", vat: 21 },
  { code: "LU", country: "Luxembourg", vat: 17 },
  { code: "LV", country: "Latvia", vat: 21 },
  { code: "MT", country: "Malta", vat: 18 },
  { code: "NL", country: "Netherlands", vat: 21 },
  { code: "PL", country: "Poland", vat: 23 },
  { code: "PT", country: "Portugal", vat: 23 },
  { code: "RO", country: "Romania", vat: 19 },
  { code: "SE", country: "Sweden", vat: 25 },
  { code: "SI", country: "Slovenia", vat: 22 },
  { code: "SK", country: "Slovakia", vat: 20 },
];
